import React from 'react';
import classnames from 'classnames';
import {FormattedMessage} from 'react-intl';
import logo from '../../../assets/logo/clean logo.png';
import styles from './PageHeader.module.scss';

export interface PageHeaderProps extends FormattedMessageProps {
  className?: string;
  values?: { [key: string]: any }
  showLogo?: boolean,
  secondaryHeader?: FormattedMessageProps & {
    className?: string;
  }
}

function PageHeader({
                      className,
                      values,
                      showLogo = false,
                      secondaryHeader,
                      ...rest
                    }: PageHeaderProps) {
  return showLogo
    ? (
      <div className={styles.pageHeaderContainerWithLogo}>
        <img src={logo} alt="logo" className={styles.logo}/>
        <div className={classnames(styles.headerContainerWithLogo, className)}>
          <div className={classnames(styles.secondaryHeader, secondaryHeader?.className)}>
            {secondaryHeader && <FormattedMessage {...secondaryHeader}/>}
          </div>
          <div className={styles.primaryHeader}>
            <FormattedMessage values={values} {...rest}/>
          </div>
        </div>
      </div>
    )
    : (
      <div className={classnames(styles.headerContainer, styles.primaryHeader, className)}>
        <FormattedMessage values={values} {...rest}/>
      </div>
    );
}

export default PageHeader;
